import {ArticleState} from '../interfaces';

export const state: ArticleState = {
  articles: [],
};
